// @spec BCP-STR-031
// Exercise schedule route page

import { createFileRoute } from '@tanstack/react-router';

import { ExerciseSchedule } from '@/features/bcp/components/ExerciseSchedule';
import i18n from '@/lib/i18n';

export const Route = createFileRoute('/_authenticated/bcp/exercises/schedule')({
  beforeLoad: () => ({
    getTitle: () => i18n.t('routeTitles.exerciseSchedule'),
  }),
  component: ExerciseSchedulePage,
});

function ExerciseSchedulePage() {
  return (
    <div className="min-h-screen bg-background p-8">
      <div className="mx-auto max-w-7xl">
        <ExerciseSchedule />
      </div>
    </div>
  );
}
